module.exports = __webpack_public_path__ + "static/media/6 Niranjan YG Brief.7f49a59d.pdf";